export const Footer: React.FC<any> = ({ isMobile }) => {
  return (
    <footer
      className={`flex w-full justify-center ${isMobile ? 'flex-col items-center p-5' : 'px-24 py-6'}`}
      style={{ background: '#00405E', color: '#fff', paddingLeft: isMobile ? '0' : '24.25vw' }}
    >
      <div className={`w-full ${isMobile ? 'flex flex-col items-center' : ''}`}>
        <div className={`mb-5 mt-5 flex ${isMobile ? 'flex-col items-center gap-2' : 'gap-24 text-xl'}`}>
          <a href="https://adm.doctor/toss/" target="_blank" rel="noopener noreferrer">
            <span className="font-bold">Termos & Condições</span>
          </a>
          <a href="https://adm.doctor/privacy-policy/" target="_blank" rel="noopener noreferrer">
            <span className="font-bold">Política de Privacidade</span>
          </a>
        </div>

        {!isMobile && <div style={{fontSize: '14px'}} className="font-light">© 2025 ADM DOCTOR S.A.</div>}

        {!isMobile && (
          <div className="absolute right-40 mt-12">
            <img src="/logos/logo-white.svg" />
          </div>
        )}

        <div
          className={`flex ${isMobile ? 'flex-col items-center' : 'mt-9'}`}
          style={{ marginLeft: isMobile ? '0' : '-12px' }}
        >
          <a
            href="https://api.whatsapp.com/send/?phone=551133362773&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img style={{ width: '160px', height: 'auto' }} src="/icons/whatsapp.png" />
          </a>
          <a href="mailto:support@admdoctor.com.br" target="_blank" rel="noopener noreferrer">
            <img style={{ width: '160px', height: 'auto' }} src="/icons/email.png" />
          </a>
        </div>

        {isMobile &&<div className="text-lg font-bold ml-1 mt-5">
          Siga as nossas redes sociais
        </div>}

        <div
          className={`mt-1 flex ${isMobile ? 'mt-1 items-center' : 'justify-between'}`}
          style={{ marginLeft: isMobile ? '0' : '-9px' }}
        >
          <div className={`flex ${isMobile ? 'ml-3 items-center' : ''}`}>
            <a href="https://www.instagram.com/admdoctor/" target="_blank" rel="noopener noreferrer">
              <img style={{width: '55px'}} className="mt-2" src="/icons/instagram.svg" />
            </a>
            <a href="https://www.linkedin.com/company/admdoctor/" target="_blank" rel="noopener noreferrer">
              <img style={{width: '55px', translate: '-4px 0'}} className="mt-2" src="/icons/linkedIn.svg" />
            </a>
            <a href="https://www.tiktok.com/@admdoctor" target="_blank" rel="noopener noreferrer">
              <img style={{width: '55px', translate: '-4px 0'}} className="mt-2" src="/icons/tiktok.svg" />
            </a>
            <a href="https://www.youtube.com/@admdoctor.oficial" target="_blank" rel="noopener noreferrer">
              <img style={{width: '55px', translate: '-4px 0'}} className="mt-2" src="/icons/youtube.svg" />
            </a>
            <a href="https://www.facebook.com/admdoctor" target="_blank" rel="noopener noreferrer">
              <img style={{width: '55px', translate: '-4px 0'}} className="mt-2" src="/icons/facebook.png" />
            </a>
          </div>
        </div>

        {isMobile && <div style={{fontSize: '13.5px'}} className="mt-6 text-xs font-light">© 2025 ADM DOCTOR S.A.</div>}

        {isMobile && (
          <div className="mt-4 pb-5">
            <img className="scale-110" src="/logos/logo-white.svg" />
          </div>
        )}

        {!isMobile && <div className="ml-1 mt-1.5 text-lg font-bold">Siga as nossas redes sociais</div>}
      </div>
    </footer>
  );
};
